





























import TimeScale from "./TimeScale.vue";//timescale component
import TraceInfoList from "./TraceInfoList.vue"//connectionsettings component //connectioninfo component
import ConnectionTimelineList from './ConnectionTimelineList.vue' //connection timeline list component
    //connectiondiagram component
import * as d3 from 'd3';
import PacketInfo from '../conntable/PacketInfo.vue';
export default {
  name: "timeline",
  computed: {
      containerwidth() {
          return window.innerWidth
      },
      containerheight() {
          return window.innerHeight * (3/5)
      },
  },
  components: {
      TraceInfoList,
      TimeScale,
      ConnectionTimelineList,
      PacketInfo
  },
}
